import React, { useState, useEffect } from "react";
import Axios from "axios";
import ReactModal from "react-modal";
import Frame from "./Frame/Frame";
import ModalContentArticle from "../ModalContent/ModalContentArticle/ModalContentArticle";
import ModalContentSurvey from "../ModalContent/ModalContentSurvey/ModalContentSurvey";
import { initPusher, subscribeChannel } from "../../services/pusherService";
import { getId } from "../../services/service";
import { BASE_URL_DEV, BASE_URL_STAGING } from "../../const";

import "./Content.scss";
import "../ModalContent/Modals.scss";

const initialContent = {
  content_type: "",
};

const modalCloseTimeoutMS = 333;

function Content() {
  const [cards, setCards] = useState([]);
  const [anchored, setAnchored] = useState([]);
  const [errored, setErrored] = useState(false);

  const [modalContent, setModalContent] = useState(initialContent);
  const [isOpenModal, setIsOpenModal] = useState(false);

  // set up Pusher subscription when episode data is available
  useEffect(() => {
    if (cards.length === 0) return;

    setAnchored([
      cards[cards.length - 2],
      cards[cards.length - 1],
      cards[0],
    ]);

    initPusher();
    let channelPusher = subscribeChannel();

    channelPusher.bind("content", (payload) => {
      setIsOpenModal(false);
      setTimeout(() => {
        setModalContent(payload);
        setIsOpenModal(payload.is_on_screen);
      }, modalCloseTimeoutMS);
    });

    channelPusher.bind("reset", () => {
      setIsOpenModal(false);
      setModalContent(initialContent);
    });

    channelPusher.bind("center", (payload) => {
      const { content_id } = payload; // TODO: figure out if `is_centered` is still relevant

      const nextCard = (cards || []).find((item) => {
        const { id } = item;
        return id === content_id;
      });

      setAnchored(prevCards => {
        const { id } = prevCards[prevCards.length - 1] || {};

        if (id === content_id) return prevCards; // prevents pulling up the same slide when clicking the anchor button again in the control panel

        return [
          ...prevCards,
          { ...nextCard, uuid: Math.random() * 100 } // prevents warning about duplicate keys
        ];
      });
    });
  }, [cards]);

  // fetch episode on first load
  useEffect(() => {
    const id = getId();
    const URL = id === "TEST"
     ? `${BASE_URL_DEV}/episodes/TEST.json`
     : `${BASE_URL_STAGING}/episodes/${id}.json`;

    Axios.get(URL)
      .then((response) => {
        setCards(response.data.others);
      })
      .catch((error) => {
        console.log(error);
        setErrored(true);
      });

    const onPressF = e => {
      if (e.key === 'f') {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen();
        } else if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    document.addEventListener('keyup', onPressF);

    return () => {
      document.removeEventListener('keyup', onPressF);
    }
  }, []);

  return (
    <div className="Content">
      <main className="Content__container">
        <div className="Content__scrim" />
        <div className="Content__frame">
          {cards.length > 0 ? (
            <Frame anchored={anchored} cards={cards} />
          ) :null}

          {cards.length === 0 && errored ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "3rem",
              }}
            >
              <p>Veuillez vérifier l'URL</p>
            </div>
          ): null}
        </div>
        <ReactModal
          isOpen={isOpenModal}
          className={"Orangerine-Modal-content"}
          overlayClassName={"Orangerine-Modal-overlay"}
          ariaHideApp={false}
          closeTimeoutMS={modalCloseTimeoutMS}
        >
          {modalContent.content_type === "article" ? (
            <ModalContentArticle modalContent={modalContent} />
          ) : modalContent.content_type === "survey" ? (
            <ModalContentSurvey modalContent={modalContent} />
          ) : null}
        </ReactModal>
      </main>
    </div>
  );
}

export default Content;
